<template lang="html">
    <span
        ref="dropdown"
        v-bind="$attrs"
        v-on="listeners"
        class="vs-con-dropdown_x relative"
        style="width: fit-content; height: fit-content"
        type="button"
    >
        <div style="z-index: 11">
            <slot :visible="isVisible" />

            <dropdown-menu
                v-if="hasCustomContent"
                ref="menu"
                :has-custom-content="hasCustomContent"
                :open-on-click="openOnClick"
                :class="menuClasses"
                :visible="isVisible"
                :justify="justify"
                :align="align"
                :hide-pointer="hidePointer"
                :color="color"
                :tooltipStyle="dropdownTooltipStyle"
                @mouseleave.native="onMouseLeave"
                @mouseenter.native="onMouseEnterMenu"
            >
                <slot name="menu"></slot>
            </dropdown-menu>
        </div>
    </span>
</template>

<script>
import DropdownMenu from './DropdownMenu.vue'

export default {
    name: 'vx-dropdown',
    inheritAttrs: false,
    components: { DropdownMenu },
    props: {
        openOnClick: {
            default: false,
            type: Boolean
        },
        isTooltip: {
            default: false,
            type: Boolean
        },
        isContextMenu: {
            default: false,
            type: Boolean
        },
        menuClass: {
            type: String,
            default: ''
        },
        justify: {
            type: String,
            validate: (v) => ['start', 'middle', 'end'].contains(v),
            default: 'center'
        },
        align: {
            type: String,
            validate: (v) => ['top', 'bottom', 'left', 'right'].contains(v),
            default: 'bottom'
        },
        hidePointer: {
            type: Boolean
        },
        visible: {
            type: Boolean,
            default: false
        },
        color: {
            type: String
        },
        dropdownTooltipStyle: {
            type: Object
        }
    },
    data: () => ({
        visible_x: false
    }),
    watch: {
        isVisible(v) {
            if (!v) {
                this.$emit('blur')
                return
            }
            this.$emit('focus')
        }
    },
    computed: {
        isVisible: {
            get() {
                if (!this.visible) {
                    return this.visible_x
                }
                return true
            },
            set(v) {
                this.visible_x = v
                return this.$emit('update:visible', v)
            }
        },

        listeners() {
            var listeners_x = {
                ...this.$listeners
            }

            if (this.contextmenu) {
                listeners_x.contextmenu = this.onContextMenu
            } else if (this.openOnClick) {
                listeners_x.click = this.onClick
            } else {
                listeners_x.mouseleave = this.onMouseLeave
                listeners_x.mouseenter = this.onMouseEnterWrapper
            }

            return listeners_x
        },
        hasCustomContent() {
            return !!this.$slots['menu']
        },
        menuElement() {
            return this.$refs.menu.$el
        },
        dropdownElement() {
            return this.$refs.dropdown
        },
        menuClasses() {
            return `${this.menuClass} ${this.menuClass_x}`
        },
        menuClass_x() {
            return `menu_${this._uid}`
        }
    },
    methods: {
        onMouseEnterWrapper(evt) {
            this.hoverToggleMenu(evt)
        },
        onMouseEnterMenu(evt) {
            if (this.isTooltip) {
                this.close()
                return
            }
            this.hoverToggleMenu(evt)
        },
        onMouseLeave(evt) {
            this.hoverToggleMenu(evt)
        },
        onClick(evt) {
            if (!this.isContextMenu) {
                this.clickToggleMenu(evt)
            }
            if (this.$el === evt.target) {
                this.$emit('click')
            }
        },
        onContextMenu(evt) {
            if (!this.isContextMenu) {
                return
            }
            this.clickToggleMenu(evt, true)
        },
        onClickOutside(evt) {
            if (this.wasFiredInside(evt)) {
                return
            }
            this.close()
        },
        open() {
            this.isVisible = true
        },
        close() {
            if (!this.isVisible) {
                return
            }
            window.removeEventListener('click', this.onClickOutside)
            this.isVisible = false
        },
        clickToggleMenu(evt) {
            if (!this.openOnClick && !this.isContextMenu) {
                this.$emit('click', evt)
                return
            }

            // ensure there is no compounding of events
            window.removeEventListener('click', this.onClickOutside)
            if (this.isVisible && !this.wasFiredInside(evt)) {
                this.close()
            } else {
                this.open()
                window.addEventListener('click', this.onClickOutside)
            }
            this.$emit('click', evt)
        },
        hoverToggleMenu(evt) {
            if (this.isContextMenu) {
                return
            }

            if (evt.type == 'mouseenter' && this.wasFiredInside(evt)) {
                this.open()
                return
            }

            if (!this.isChild(evt.relatedTarget)) {
                this.close()
            }
        },
        wasFiredInside(evt) {
            var pathWhenEventFired = evt.composedPath()
            return (
                pathWhenEventFired.contains(this.dropdownElement) ||
                pathWhenEventFired.contains(this.menuElement)
            )
        },
        isChild(el) {
            if (!el) {
                return false
            }
            return el.classList.contains(this.menuClass_x) || !!el.closest(`.${this.menuClass_x}`)
        }
    },
    beforeDestroy() {
        window.removeEventListener('click', this.onClickOutside)
    }
}
</script>

<style scoped lang="scss">
.vs-con-dropdown_x {
    color: inherit;
    position: relative;
    display: inline-block;
    border: 0;
    background: transparent;
    cursor: pointer;
}
.vs-con-dropdown_x {
    color: inherit;
    font-size: 1rem;
    position: relative;
    display: inline-block;
    border: 0;
    background: transparent;
}
</style>
